#import "../fragments/mcfx-company-fragment.graphql"

mutation McfxCompaniesUnlock($input: McfxCompaniesUnlockInput!) {
    mcfxCompaniesUnlock(input: $input) {
        mcfxCompanies {
            ...McfxCompanyFragment
        }
    }
}
